var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconPlay05 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 12 12"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "url(#icon_play_05_svg__a)",
  fillOpacity: 0.8,
  fillRule: "evenodd",
  d: "m2.682 11.521 7.735-4.54a1.11 1.11 0 0 0 .582-.949 1.111 1.111 0 0 0-.516-.975L3.562.654a1.118 1.118 0 0 0-1.717.993V8.83l2.413-1.494V3.744L7.745 5.96 1.551 9.595a1.117 1.117 0 0 0 1.13 1.926",
  clipRule: "evenodd"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "icon_play_05_svg__a",
  x1: 6,
  x2: 6,
  y1: 0.48,
  y2: 11.675,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF3D22"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F01478"
})))));
export default SvgIconPlay05;